// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__17NsH","buttonSmall":"Button_buttonSmall__3zEwJ","buttonBack":"Button_buttonBack__ppGhT"};